import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  EditButton,
  DeleteButton,
  ChipField,
  FunctionField,
  ReferenceField,
} from 'react-admin';

const PromoCodeList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="code" label="Код" />
      <ReferenceField source="productId" reference="products" label="Продукт">
        <TextField source="title" />
      </ReferenceField>
      <ChipField source="type" label="Тип" />
      <FunctionField
        label="Значение"
        render={(record: any) => 
          record.type === 'percentage' 
            ? `${record.value}%` 
            : `${record.value} ₽`
        }
      />
      <DateField source="validFrom" label="Действует с" showTime />
      <DateField source="validUntil" label="Действует до" showTime />
      <FunctionField
        label="Использований"
        render={(record: any) => 
          `${record.currentUsageCount}${record.maxUsageCount ? `/${record.maxUsageCount}` : ''}`
        }
      />
      <BooleanField source="isActive" label="Активен" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export default PromoCodeList;